import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n\n\nbody {\n  margin: 0;\n  font-family: ", ", sans-serif;\n  font-weight: 400;\n  font-size: 0.875rem;\n  box-sizing: border-box;\n  max-width: 100%;\n  background-color: ", ";\n  overflow-x: hidden;\n  color: ", ";\n}\n\nhtml, body {\ntext-rendering: optimizeLegibility; \n-webkit-font-smoothing: subpixel-antialiased; \n\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  line-height: 1;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n\n.Toastify__toast {\n    min-height: 3rem;\n    padding: 1rem;\n    font: inherit;\n}\n\n.Toastify__toast-body {\n  /* display: -webkit-box;\n  -webkit-line-clamp:3;;\n  -webkit-box-orient:vertical; \n  overflow:hidden; */\n  margin-right: 0.5rem;\n}\n\n.Toastify__toast--success {\n  background: ", ";\n}\n\n.Toastify__toast--error {\n  background: ", ";\n}\n\n\n*,\n*:after,\n*:before {\n  box-sizing: border-box;\n  /* -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; */\n}\n\n\n/* Focusing the button with a keyboard will show a dashed black line. */\n*:focus-visible {\n  outline: 2px dashed black;\n}\n\n/* Focusing the button with a mouse, touch, will not show any outline */\n*:focus:not(:focus-visible) {\n  outline: none;\n}\n\n\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider as SCThemeProvider, createGlobalStyle } from 'styled-components';
import lightTheme from './lightTheme';
export var GlobalStyle = createGlobalStyle(_templateObject(), function (props) {
  return props.theme.fontFamilies.inter;
}, function (props) {
  return props.theme.colors.accent1;
}, function (props) {
  return props.theme.colors.foreground;
}, function (props) {
  return props.theme.colors.success;
}, function (props) {
  return props.theme.colors.error;
});

function ThemeProvider(_ref) {
  var children = _ref.children;
  return _jsxs(SCThemeProvider, Object.assign({
    theme: lightTheme
  }, {
    children: [_jsx(GlobalStyle, {}, void 0), children]
  }), void 0);
}

export default ThemeProvider;